import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { ConfirmationService } from 'primeng/api';
import { TransicionEstadoUdInspeccionCamService } from '../transicionestadoudinspeccioncam.service';
import {
    FilterSearchingTransicionEstadoUdInspeccionCamViewModel,
    TransicionEstadoUdInspeccionCamItemResultsViewModel,
} from '../transicionestadoudinspeccioncam.types';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { CampaniasGlobalService } from '../../../../_campanias/services/global-campanias.service';
import { EnumIdsTcPerfilUsuario } from '../../../../_importacion/solicitudes/types/enum';
import { EnumIdsTcEstadoUnidadInspeccion } from 'src/app/components/_campanias/types/enum';

@Component({
    selector: 'app-transicionestadoudinspeccioncam-wrapper',
    templateUrl: './transicionestadoudinspeccioncam-wrapper.component.html',
})
export class TransicionEstadoUdInspeccionCamWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    result: TransicionEstadoUdInspeccionCamItemResultsViewModel | null;
    payload?: FilterSearchingTransicionEstadoUdInspeccionCamViewModel;
    edition = false;

    listPerfilesUsuario: Tc[];
    listTiposInspeccionCam: Tc[];
    listEstadosUnidadInspeccionCam: Tc[];
    listResultadosInspeccionCam: Tc[];

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private transicionEstadoUdInspeccionCamService: TransicionEstadoUdInspeccionCamService,
        private router: Router,
        private confirmationService: ConfirmationService,
        private globalService: GlobalService,
        private campaniasGlobalService: CampaniasGlobalService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    private getListas(): void {
        this.getResultadosInspeccionCam();
        this.getEstadosUnidadInspeccionCam();
        this.getTiposInspeccionCam();
        this.getPerfilesUsuario();
    }

    private getTiposInspeccionCam(): void {
        this.globalService.getTiposInspeccionCam().subscribe(res => {
            this.listTiposInspeccionCam = res;
        });
    }

    private getEstadosUnidadInspeccionCam(): void {
        this.campaniasGlobalService.getEstadosUnidadInspeccion().subscribe(res => {
            this.listEstadosUnidadInspeccionCam = res?.filter(estado => estado.Id !== EnumIdsTcEstadoUnidadInspeccion.ID_SIN_ASIGNAR); // El estado sin asignar no se trata en la transición de estados
        });
    }

    private getResultadosInspeccionCam(): void {
        this.campaniasGlobalService.getListaResultadosInspeccionCam().subscribe(res => {
            this.listResultadosInspeccionCam = res;
        });
    }

    private getPerfilesUsuario(): void {
        this.globalService.getPerfilesUsuario().subscribe((listPerfilesUsuario: Tc[]) => {
            this.listPerfilesUsuario = listPerfilesUsuario?.filter(
                listPerfilesUsuario =>
                    listPerfilesUsuario.Id === EnumIdsTcPerfilUsuario.ID_ADMINISTRADOR ||
                    listPerfilesUsuario.Id === EnumIdsTcPerfilUsuario.ID_ENTIDAD_AUDITORA ||
                    listPerfilesUsuario.Id === EnumIdsTcPerfilUsuario.ID_COMUNIDAD_AUTONOMA,
            );
        });
    }

    ngOnInit(): void {
        this.getListas();
        this.recoverLastSearch();
    }

    onSearch(payload: FilterSearchingTransicionEstadoUdInspeccionCamViewModel): void {
        if (!payload) {
            return;
        }

        this.payload = { ...payload } as FilterSearchingTransicionEstadoUdInspeccionCamViewModel; // To keep a copy to be used in the lazy search (paginator)

        this.transicionEstadoUdInspeccionCamService.getTransicionesEstadosUdsInspeccionCam(payload).subscribe(results => {
            this.result = results;
            this.searching = true;
        });
    }

    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingTransicionEstadoUdInspeccionCamViewModel;
        this.onSearch(payload);
    }

    onReset(): void {
        this.searching = false;
        this.result = null;
        this.transicionEstadoUdInspeccionCamService.clearLastSearch();
    }

    onAdd(): void {
        this.edition = true;
        this.router.navigate(['/mantenimiento/general/transicionestadoudinspeccioncam/create']);
    }

    onEdit(itemId: number | null): void {
        this.edition = true;
        this.router.navigate(['/mantenimiento/general/transicionestadoudinspeccioncam/edit', itemId]);
    }

    onDelete(id: number): void {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                this.transicionEstadoUdInspeccionCamService.deleteTransicionEstadoUdInspeccionCam(id).subscribe({
                    next: () => {
                        this.addSuccessMessage('Transición de estados para la Unidad de Inspección de Campañas eliminada correctamente');
                        this.recoverLastSearch();
                        this.onSearch(this.payload!);
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    private recoverLastSearch() {
        this.payload = this.transicionEstadoUdInspeccionCamService.getLastSearch();
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;

        let model: FilterSearchingTransicionEstadoUdInspeccionCamViewModel = new FilterSearchingTransicionEstadoUdInspeccionCamViewModel();
        Object.assign(model, this.payload);

        this.transicionEstadoUdInspeccionCamService.export(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    exportIsAvailable(): boolean {
        return this.result?.ResultList ? this.result?.ResultList?.length > 0 : false;
    }
}
